export const SET_CONFIG = "SET_CONFIG";
export const FETCH_CONFIG_INIT = "FETCH_CONFIG_INIT";
export const FETCH_COMPLETE = "FETCH_COMPLETE";
export const SET_APP_CONFIG = "SET_APP_CONFIG";
export const RESET_APP_CONFIG = "RESET_APP_CONFIG";
export const SET_BILLING_DEFAULTS = "SET_BILLING_DEFAULTS";
export const SET_BILLING_ALL = "SET_BILLING_ALL";
export const SET_SYSTEM_PARAMETER = "SET_SYSTEM_PARAMETER";
